(function () {
  var HIDDEN_CLASS = 'is-hidden-variant-media';
  var ALL_KEYWORD = 'all';
  var ORIGINAL_INDEX_ATTR = 'data-original-media-index';
  var FILTERED_ATTR = 'data-variant-media-filtered';

  function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function normalizeText(value) {
    return (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function altMatchesKeyword(alt, keyword) {
    var normalizedAlt = normalizeText(alt);
    var normalizedKeyword = normalizeText(keyword);
    if (!normalizedAlt || !normalizedKeyword) return false;
    if (normalizedAlt === normalizedKeyword) return true;
    var pattern = new RegExp('(?:^|[^a-z0-9])' + escapeRegExp(normalizedKeyword) + '(?:[^a-z0-9]|$)', 'i');
    return pattern.test(normalizedAlt);
  }

  function getItemAlt(item) {
    if (!item) return '';
    if (item.getAttribute('data-media-alt')) return item.getAttribute('data-media-alt');
    if (item.getAttribute('data-label')) return item.getAttribute('data-label');
    var labeledChild = item.querySelector('[data-media-alt]');
    if (labeledChild && labeledChild.getAttribute('data-media-alt')) {
      return labeledChild.getAttribute('data-media-alt');
    }
    var image = item.querySelector('img');
    return image && image.getAttribute('alt') ? image.getAttribute('alt') : '';
  }

  function getOriginalIndex(item) {
    var value = item.getAttribute(ORIGINAL_INDEX_ATTR);
    return value == null ? 0 : parseInt(value, 10);
  }

  function sortByOriginalIndex(a, b) {
    return getOriginalIndex(a) - getOriginalIndex(b);
  }

  function rememberOriginalOrder(items) {
    items.forEach(function (item, index) {
      if (!item.hasAttribute(ORIGINAL_INDEX_ATTR)) {
        item.setAttribute(ORIGINAL_INDEX_ATTR, String(index));
      }
    });
  }

  function setItemVisibility(item, isVisible) {
    item.classList.toggle(HIDDEN_CLASS, !isVisible);
    if (isVisible) {
      item.style.removeProperty('display');
    } else {
      item.style.display = 'none';
    }
  }

  function restoreItems(items, parent, trailingEl) {
    items.sort(sortByOriginalIndex).forEach(function (item) {
      setItemVisibility(item, true);
      parent.appendChild(item);
    });
    if (trailingEl) parent.appendChild(trailingEl);
    parent.removeAttribute(FILTERED_ATTR);
  }

  function getSizeRadios() {
    var radios = [];
    var scoped = document.querySelectorAll(
      'product-section input[type="radio"], new-variant-radios input[type="radio"], variant-radios input[type="radio"], .pdp-hero__variant-radios input[type="radio"]'
    );

    scoped.forEach(function (input) {
      if (!input.name || input.name.toLowerCase().trim() !== 'size') return;
      if (input.closest('.gift__product--wrap, .gift__popup--wrap, .candies__product--wrap')) return;
      if (radios.indexOf(input) === -1) radios.push(input);
    });

    return radios;
  }

  function getSelectedSize() {
    var selected = null;
    getSizeRadios().forEach(function (input) {
      if (input.checked) selected = input.value;
    });
    return selected;
  }

  function getSizeValues() {
    var values = [];
    getSizeRadios().forEach(function (input) {
      if (input.value && values.indexOf(input.value) === -1) {
        values.push(input.value);
      }
    });
    return values;
  }

  function getFeaturedItem(items) {
    var featured = null;
    items.forEach(function (item) {
      if (featured) return;
      if (item.getAttribute('data-featured') === 'true') featured = item;
    });
    if (featured) return featured;

    items.forEach(function (item) {
      if (featured) return;
      if (getOriginalIndex(item) === 0) featured = item;
    });

    return featured || items[0] || null;
  }

  function classifyItem(item, sizeValues) {
    var alt = getItemAlt(item);
    var matchedSize = null;

    sizeValues.forEach(function (sizeValue) {
      if (!matchedSize && altMatchesKeyword(alt, sizeValue)) {
        matchedSize = sizeValue;
      }
    });

    return {
      item: item,
      matchedSize: matchedSize,
      isAll: altMatchesKeyword(alt, ALL_KEYWORD)
    };
  }

  function filterItemGroup(items, parent, sizeValue, sizeValues, trailingEl) {
    if (!parent || !items.length) return false;

    rememberOriginalOrder(items);

    var classified = items.map(function (item) {
      return classifyItem(item, sizeValues);
    });

    var hasVariantSpecific = classified.some(function (entry) {
      return !!entry.matchedSize;
    });
    var hasAll = classified.some(function (entry) {
      return entry.isAll;
    });

    if (!hasVariantSpecific && !hasAll) {
      if (parent.hasAttribute(FILTERED_ATTR)) {
        restoreItems(items, parent, trailingEl);
      }
      return false;
    }

    var variantItems = [];
    var allItems = [];

    classified.forEach(function (entry) {
      if (entry.isAll) {
        allItems.push(entry.item);
        return;
      }

      if (entry.matchedSize && normalizeText(entry.matchedSize) === normalizeText(sizeValue)) {
        variantItems.push(entry.item);
      }
    });

    variantItems.sort(sortByOriginalIndex);
    allItems.sort(sortByOriginalIndex);

    var visibleItems = variantItems.concat(allItems);

    if (!visibleItems.length) {
      var featuredItem = getFeaturedItem(items);
      if (featuredItem) visibleItems = [featuredItem];
    }

    var visibleMap = {};
    visibleItems.forEach(function (item) {
      visibleMap[item.getAttribute(ORIGINAL_INDEX_ATTR)] = true;
    });

    items.forEach(function (item) {
      setItemVisibility(item, !!visibleMap[item.getAttribute(ORIGINAL_INDEX_ATTR)]);
    });

    visibleItems.forEach(function (item) {
      parent.appendChild(item);
    });

    items.forEach(function (item) {
      if (!visibleMap[item.getAttribute(ORIGINAL_INDEX_ATTR)]) {
        parent.appendChild(item);
      }
    });

    if (trailingEl) parent.appendChild(trailingEl);
    parent.setAttribute(FILTERED_ATTR, 'true');
    return true;
  }

  function getMediaGroups() {
    var groups = [];

    document.querySelectorAll('.product__container .product__media-wrapper').forEach(function (wrapper) {
      wrapper.querySelectorAll('.product__media-list, .product__thumb-list').forEach(function (list) {
        var parent = list.querySelector('.swiper-wrapper') || list;
        var items = Array.prototype.slice.call(parent.querySelectorAll(':scope > .product__media-item'));
        if (!items.length) {
          items = Array.prototype.slice.call(list.querySelectorAll('.product__media-item'));
        }
        groups.push({
          items: items,
          parent: parent,
          trailingEl: null,
          isSwiper: list.classList.contains('swiper') || !!list.swiper
        });
      });
    });

    document.querySelectorAll('.pdp-hero__thumbs, .main-product-2026__thumbs').forEach(function (parent) {
      var items = Array.prototype.slice.call(parent.querySelectorAll('.pdp-hero__thumb, .main-product-2026__thumb, [data-thumb]'));
      groups.push({ items: items, parent: parent, trailingEl: null, isSwiper: false });
    });

    document.querySelectorAll('.pdp-hero__main-image-area, .main-product-2026__main-image-area').forEach(function (parent) {
      var items = Array.prototype.slice.call(parent.querySelectorAll('.pdp-hero__main-slide, .main-product-2026__main-slide, [data-main-slide]'));
      var trailingEl = parent.querySelector('.pdp-hero__mobile-nav, .main-product-2026__mobile-nav');
      groups.push({ items: items, parent: parent, trailingEl: trailingEl, isSwiper: false });
    });

    return groups;
  }

  function refreshSwipers() {
    document.querySelectorAll('.product__media-list.swiper, .product__media-list-mobile.swiper, .product__thumb-list.swiper').forEach(function (el) {
      if (!el.swiper || typeof Swiper === 'undefined') return;

      var params = Object.assign({}, el.swiper.passedParams || el.swiper.params);
      var firstVisible = Array.prototype.slice.call(el.querySelectorAll('.swiper-slide')).findIndex(function (slide) {
        return !slide.classList.contains(HIDDEN_CLASS);
      });

      try {
        el.swiper.destroy(true, true);
        var nextSwiper = new Swiper(el, params);
        if (firstVisible > 0 && nextSwiper && typeof nextSwiper.slideTo === 'function') {
          nextSwiper.slideTo(firstVisible, 0);
        }
      } catch (error) {
        if (el.swiper && typeof el.swiper.update === 'function') {
          el.swiper.update();
        }
      }
    });
  }

  function activateFirstVisiblePdpImage() {
    document.querySelectorAll('.pdp-hero-product').forEach(function (section) {
      var thumbs = Array.prototype.slice.call(section.querySelectorAll('.pdp-hero__thumb'));
      var slides = Array.prototype.slice.call(section.querySelectorAll('.pdp-hero__main-slide'));
      var firstVisible = thumbs.findIndex(function (thumb) {
        return !thumb.classList.contains(HIDDEN_CLASS);
      });
      if (firstVisible < 0) firstVisible = 0;

      thumbs.forEach(function (thumb, index) {
        thumb.classList.toggle('is-active', index === firstVisible);
      });
      slides.forEach(function (slide, index) {
        slide.classList.toggle('is-active', index === firstVisible);
      });

      var mobileNav = section.querySelector('.pdp-hero__mobile-nav');
      if (mobileNav) {
        var visibleCount = slides.filter(function (slide) {
          return !slide.classList.contains(HIDDEN_CLASS) && slide.style.display !== 'none';
        }).length;
        mobileNav.classList.toggle('has-one-slide', visibleCount <= 1);
      }
    });

    document.querySelectorAll('new-product-gallery').forEach(function (gallery) {
      var firstVisible = gallery.querySelector('[data-main-slide]:not(.' + HIDDEN_CLASS + ')');
      if (!firstVisible) return;

      gallery.thumbs = gallery.querySelectorAll('[data-thumb]');
      gallery.mainSlides = gallery.querySelectorAll('[data-main-slide]');

      if (typeof gallery.findNewIndex === 'function' && typeof gallery.updateActiveIndex === 'function') {
        gallery.updateActiveIndex(gallery.findNewIndex(firstVisible));
      }
      if (typeof gallery.updateMobileNavVisibility === 'function') {
        gallery.updateMobileNavVisibility();
      }
      if (typeof gallery.findNewIndex !== 'function' || typeof gallery.updateActiveIndex !== 'function') {
        gallery.querySelectorAll('[data-thumb], [data-main-slide]').forEach(function (el) {
          el.classList.remove('is-active');
        });
        firstVisible.classList.add('is-active');
        var firstThumb = gallery.querySelector('[data-thumb][data-id="' + firstVisible.getAttribute('data-id') + '"]');
        if (firstThumb) firstThumb.classList.add('is-active');
      }
    });
  }

  function scrollDesktopMediaToTop() {
    document.querySelectorAll('.product__media-wrapper.desktop__media').forEach(function (wrapper) {
      wrapper.scrollTop = 0;
    });
  }

  function applySizeFilter(sizeValue) {
    if (!sizeValue) return;

    var sizeValues = getSizeValues();
    if (!sizeValues.length) return;

    var didFilter = false;
    getMediaGroups().forEach(function (group) {
      if (filterItemGroup(group.items, group.parent, sizeValue, sizeValues, group.trailingEl)) {
        didFilter = true;
      }
    });

    if (!didFilter) return;

    refreshSwipers();
    activateFirstVisiblePdpImage();
    scrollDesktopMediaToTop();
  }

  function applyCurrentSizeFilter() {
    var selectedSize = getSelectedSize();
    if (selectedSize) applySizeFilter(selectedSize);
  }

  function isMainProductSizeInput(input) {
    if (!input || input.type !== 'radio') return false;
    if (!input.name || input.name.toLowerCase().trim() !== 'size') return false;
    return getSizeRadios().indexOf(input) !== -1;
  }

  document.addEventListener('change', function (event) {
    if (isMainProductSizeInput(event.target)) {
      applySizeFilter(event.target.value);
    }
  });

  document.addEventListener('variant:change', function () {
    var selectedSize = getSelectedSize();
    if (selectedSize) applySizeFilter(selectedSize);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      applyCurrentSizeFilter();
      window.setTimeout(applyCurrentSizeFilter, 0);
    });
  } else {
    applyCurrentSizeFilter();
  }

  window.FreshSendsVariantMedia = {
    apply: applySizeFilter,
    applyCurrent: applyCurrentSizeFilter
  };
})();
